/**
 * Created by tomers on 7/28/2014.
 *
 * Responsible for all data in the manager module.
 *
 * NOTE for categories API & merged Collection:
 * For Categories we handle 2 collection:
 * 1) Regular persisted Categories Collection (every 2 minutes)
 * 2) Merged Collection of Categories and Dependencies - persist by demand and can be stopped.
 * For the merged collection we handle (and dummy) the fetch:success trigger and the fetchState attribute because this collection never being fetched from the server and we set the models manually.
 * The "fetch:success" event is triggered only after we take the models from the Categories Collection and set the dependencies (this in order to avoid a flicker in the UI)
 * How the merged collection is updated flow:
 *  - The merged collection listens to changes in the categories collection (fetch & add, the remove is not triggered because the categories collection has specific destroy method as described in its documentation)
 *  - The controller loads the dependencies for the categories
 *  - We take the category model's JSON and assign the dependency (We are using the JSON and not the model itself because we don't want to affect the original models)
 *  - We set this array of JSONs to the merged collection.
 * Note: We are using the 'set' method instead of 'reset' because 'reset' init the models array and there some decorators such as 'Selectable' that depends on the original 'models' pointer.
 * The grid view should be updated after the "fetch:success" from the merged collection. This is because the organizer listens to "fetch:success", organize the collection and triggers the "reset"
 */
define(function (require) {
    "use strict";

    var CategoriesCollection = require("manager-collections/CategoriesCollection");
    var DependencyService = require("src/components/dependency-service/controllers/DependencyService");

    var Minute = 60000;

    var DataManagerController = {};
    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {
        DataManagerController = Marionette.Controller.extend({
            persistedCollections: {
                //categoriesCollection: new CategoriesCollection([],{fetchInterval: 2 * Minute})
            },
            revisionedCollections: {
                categoriesCollection: new CategoriesCollection([])
            },
            mergedCollections: {
                categoriesWithDependencies: new CategoriesCollection([])
            },

            initialize: function() {
                LEManager.logger.info ("initializing","DataManagerController:initialize");
                this.started = false;
            },

            start: function() {
                LEManager.logger.debug ("starting","DataManagerController:start");

                if (!this.started) {
                    this._fetchAllRevisioned();
                    this._fetchAllPersisted();
                    this.started = true;
                }
            },

            getDependencyData: function(dependencyModel) {
                return LEManager.getModuleDataManager().getDependencyData(dependencyModel);
            },

            _fetchAllRevisioned: function() {
                LEManager.logger.debug ("fetch all revisioned collections","DataManagerController:_fetchAllRevisioned");

                _.each(this.revisionedCollections, function(revisionedCollection) {
                    LEManager.logger.debug ("fetch collection","DataManagerController:_fetchAllRevisioned", revisionedCollection);
                    if (!_.isUndefined(revisionedCollection.url)){
                        revisionedCollection.fetch();
                    }
                });
             },

            _fetchAllPersisted: function() {
                LEManager.logger.debug ("persist all persisted collections","DataManagerController:_fetchAllPersisted");

                _.each(this.persistedCollections, function(persistedCollection) {
                    LEManager.logger.debug ("persist collection","DataManagerController:_fetchAllPersisted", persistedCollection);
                    persistedCollection.persist();
                });
            },

            _refreshCategoriesWithDependenciesCollection: function() {
                LEManager.logger.debug ("refresh the categories with dependencies collection","DataManagerController:_refreshCategoriesWithDependenciesCollection");

                this._loadCategoriesDependencies();
            },

            _loadCategoriesDependencies: function() {
                LEManager.logger.debug ("load dependencies for categories","DataManagerController:_loadCategoriesDependencies", this.revisionedCollections.categoriesCollection);

                DependencyService.getDependencies(this.revisionedCollections.categoriesCollection, {
                    success: _.bind(this._onCategoriesDependenciesFetchSuccess, this),
                    error: _.bind(this._onCategoriesDependenciesFetchError, this)
                });
            },

            _onCategoriesDependenciesFetchSuccess: function(collection, response, options) {
                LEManager.logger.debug ("dependencies fetched successfully","DataManagerController:_onCategoriesDependenciesFetchSuccess", collection);

                this._updateCategoriesWithDependenciesModels(collection);

                // this is a dummy fetch:success trigger. this is not a collection that uses 'fetch' method, so we need to dummy the fetch:success trigger when categories + dependencies are fetched
                var successState = this.mergedCollections.categoriesWithDependencies.FetchStateEnum.SUCCESS;
                LEManager.logger.debug ("set the categories and dependencies collection fetch state to " + successState,"DataManagerController:_onCategoriesDependenciesFetchSuccess", successState);
                this.mergedCollections.categoriesWithDependencies.setFetchState(successState);
            },

            _onCategoriesDependenciesFetchError: function(collection, response, options) {
                LEManager.logger.debug ("dependencies fetched error","DataManagerController:_onCategoriesDependenciesFetchError", collection);

                // todo: handle error on dependency

                // this is a dummy fetch:error trigger. this is not a collection that uses 'fetch' method, so we need to dummy the fetch:error trigger when categories + dependencies have an error
                var errorState = this.mergedCollections.categoriesWithDependencies.FetchStateEnum.ERROR;
                LEManager.logger.debug ("set the categories and dependencies collection fetch state to " + errorState,"DataManagerController:_onCategoriesDependenciesFetchError", errorState);
                this.mergedCollections.categoriesWithDependencies.setFetchState(errorState);
            },

            /**
             * Go over all the categories and look for dependencies in the dependencies collection.
             * If it has dependencies - update the JSON, if not - set 0.
             * Set the array of JSONs on the merged collection silently.
             * It should be silent because the Success function (_onCategoriesDependenciesFetchSuccess) trigger the dummy event for "fetch:success"
             * @param dependencyCollection
             * @private
             */
            _updateCategoriesWithDependenciesModels: function(dependencyCollection) {
                LEManager.logger.debug ("update the categories collection with the dependencies","DataManagerController:_updateCategoriesWithDependenciesModels");

                var categoryModelKEYS = CategoriesCollection.Model.KEYS;

                var categoriesModelsJSONs = this.revisionedCollections.categoriesCollection.map(function(categoryModel){
                    var categoryModelJSON = categoryModel.toJSON();
                    var dependencyCategoryModel = (!_.isEmpty(dependencyCollection)) ? dependencyCollection.get(categoryModelJSON.id.toString()) : null;
                    var numOfAssignedCampaigns = (!_.isEmpty(dependencyCategoryModel)) ? dependencyCategoryModel.get("dependencies").where({"type":"LECampaignObject"}).length : 0;
                    var numOfAssignedContent = (!_.isEmpty(dependencyCategoryModel)) ? dependencyCategoryModel.get("dependencies").where({"type":"ACCannedResponse"}).length : 0;
                    categoryModelJSON[categoryModelKEYS.ASSIGNED_CAMPAIGNS] = numOfAssignedCampaigns;
                    categoryModelJSON[categoryModelKEYS.ASSIGNED_CONTENT] = numOfAssignedContent;

                    return categoryModelJSON;
                });

                this.mergedCollections.categoriesWithDependencies.set(categoriesModelsJSONs, {sort:false, silent:true});
            },

            persistCategoriesWithDependencies: function(isPersist) {
                if (isPersist) {
                    LEManager.logger.debug ("start persistence of categories with the dependencies collection","DataManagerController:persistCategoriesWithDependencies");
                    this.revisionedCollections.categoriesCollection.onInitialFetched(_.bind(function(){
                        this._refreshCategoriesWithDependenciesCollection();
                        this.listenTo(this.revisionedCollections.categoriesCollection, "fetch:success", this._refreshCategoriesWithDependenciesCollection);
                        this.listenTo(this.revisionedCollections.categoriesCollection, "add", this._refreshCategoriesWithDependenciesCollection);
                    }, this));
                }
                else {
                    LEManager.logger.debug ("stop persistence of categories with the dependencies collection","DataManagerController:persistCategoriesWithDependencies");
                    this.stopListening(this.revisionedCollections.categoriesCollection, "fetch:success");
                    this.stopListening(this.revisionedCollections.categoriesCollection, "add");
                }
            },

            isAddCategoryEnabled: function() {
                return (this.revisionedCollections.categoriesCollection.size() < this.revisionedCollections.categoriesCollection.getMaxSize());
            },

            getCategoriesCollection: function() {
                return this.revisionedCollections.categoriesCollection;
            },

            getCategoriesCollectionMaxSize: function() {
                return this.revisionedCollections.categoriesCollection.getMaxSize();
            },

            getCategoriesWithDependenciesCollection: function() {
                return this.mergedCollections.categoriesWithDependencies;
            }
        });

    });


    return DataManagerController;
});

